import api from './api';

const reportService = {
  // 代理輸贏報表
  getAgentWinLoss: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/report/agent-win-loss?${queryString}`);
  },

  // 下級代理明細
  getSubAgentsDetail: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/report/sub-agents-detail?${queryString}`);
  },

  // 直屬玩家明細
  getDirectPlayersDetail: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/report/direct-players-detail?${queryString}`);
  },

  // 投注記錄查詢
  getBettingRecords: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/report/betting-records?${queryString}`);
  },

  // 獲取所有下級會員列表
  getAllMembers: async () => {
    return await api.get('/agent/manage/all-members?page=1&limit=1000');
  },

  // 匯出投注記錄 - 已移除，待後續實現
  // exportBettingRecords: async (params) => {
  //   const queryString = new URLSearchParams(params).toString();
  //   return await api.get(`/agent/report/betting-records/export?${queryString}`, {
  //     responseType: 'blob'
  //   });
  // },

  // 代理業績排行（管理員專用）
  getAgentRanking: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/report/agent-ranking?${queryString}`);
  }
};

export default reportService;